import './videoblock.scss'

import {VideoBlockType} from 'campagne/types'
import React, {useState} from 'react'
import ReactPlayer from 'react-player'
import {style} from 'util/campagne/style'
import {Block} from '../blocks'

const styles = style('videoblock', ['container'])

export const VideoContainer: React.FC<{url: string}> = ({url}) => {
	const [isPlaying, setPlaying] = useState(false)
	const [isReady, setReady] = useState(false)

	return (
		<div class={styles.container.is({ready: isReady})}>
			<a
				class={styles.container('startstop').is({playing: isPlaying})}
				onClick={() => setPlaying(!isPlaying)}
			/>
			<ReactPlayer
				url={url}
				onReady={() => setReady(true)}
				playing={isPlaying}
				height={'100%'}
				width={'100%'}
				controls={false}
				style={{
					position: 'absolute',
					left: 0,
					right: 0,
					zIndex: 1
				}}
			/>
		</div>
	)
}

const VideoBlock: React.FC<VideoBlockType> = ({url}) => (
	<Block class={styles}>
		<VideoContainer url={url} />
	</Block>
)
export default VideoBlock
